import { InjectionToken } from '@angular/core';

/** Shows the raw result JSON behind "Details". Apps provide it from `environment.enableTestDataViewer`. */
export const ENABLE_TEST_DATA_VIEWER = new InjectionToken<boolean>('enableTestDataViewer', {
  providedIn: 'root',
  factory: () => false,
});
